import { TranslatedString } from '@skinsoft/i18n';
import { get } from 'lodash';
import VueI18n from 'vue-i18n';
import { Component, Vue } from 'vue-property-decorator';

declare const FALLBACK_LOCALE;

export function getTranslatedString(value, locale, fallbackLocale: string = FALLBACK_LOCALE) {
    let fragment = get(value, ['translatedString', locale], "");
    if (!fragment && fallbackLocale) {
        fragment = get(value, ['translatedString', fallbackLocale], "");
    }
    return fragment;
}

export function createTranslatedString(locale, defaultValue: string | null = null) {
    return { translatedString: { [locale]: defaultValue } };
}

export function createTranslatedStringArray(locale: string, values: string[]) {
    return values.map(
        value => createTranslatedString(locale, value)
    )
}

@Component({
    props: {
        tag: {
            required: false,
            type: String,
        },
        value: [Number, String, Object],
        values: {
            required: false,
            type: [Array, Object],
        },
    },
})
export class LocalizedString extends Vue {
    public tag: string;
    public value: string | TranslatedString;
    public values: any[] | Record<string, any>;

    public $i18n: VueI18n;

    public render(createElement) {
        let message = "";
        // Value is a translation key, looking in locales.ts
        if (typeof this.value === "string") {
            message = this.$te(this.value, this.$i18n.locale) ?
                this.$t(this.value, this.values) as string : this.value;
        }
        // Value is a translated string, unmarshalling it with current locale
        else {
            message = getTranslatedString(this.value, this.$i18n.locale, FALLBACK_LOCALE)
        }

        return createElement(this.tag || 'span', message);
    }
}
